<div
  class="popover-wrapper"
  v-on="eventBindings"
>
  <!-- Trigger -->
  <div class="popover-trigger">
    <slot name="trigger" />
  </div>

  <!-- Content -->
  <transition name="fade">
    <div v-if="visible" class="popover-content">
      <div class="popover-holder">
        <slot name="content" />
      </div>
    </div>
  </transition>
</div>
